export const fr = {
    ScopeSelector: {
        triggerAriaLabel: "Changer la portée, sélection actuelle {{current}}",
        reportsScopeAriaLabel: "Portée des subordonnés",
        scope: {
            myTeam: "Mon équipe",
            organization: "Tout le monde",
            allReports: "Tous les subordonnés",
            directReports: "Subordonnés directs"
        },
        liveRegion: {
            loading: "Chargement des aperçus de la portée"
        }
    }
};
